import { sendRequest } from "../../hooks/requests/useRequest";

export async function getInformationQuoter (_mfrom,_mto,_code_quoter)
{
    const requestOptions = {
        method: "GET",
    };

    let _url =  `Quoter/ReportQuoter?date_ini=${_mfrom}&date_end=${_mto}` 
    const response = await sendRequest(requestOptions, _url);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}